import { render, staticRenderFns } from "./ShoppingView.vue?vue&type=template&id=2e3e62ec&scoped=true"
import script from "./ShoppingView.vue?vue&type=script&lang=js"
export * from "./ShoppingView.vue?vue&type=script&lang=js"
import style0 from "./ShoppingView.vue?vue&type=style&index=0&id=2e3e62ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3e62ec",
  null
  
)

export default component.exports